<template>
  <div class="linexo" :class="{ 'calculator-with-content--mini': selectedVariant === 'mini' }">
    <template v-if="isInitialized">
      <section v-if="contentSchema?.intro.length" class="lnx-container partner-content partner-content--intro">
        <MContent v-for="(element, index) in contentSchema.intro" :key="index" :config="element.config" />
      </section>
      <component :is="applicationVariants[(selectedVariant as keyof typeof applicationVariants) ?? 'default']" />
      <section v-if="contentSchema?.outro.length" class="lnx-container partner-content partner-content--outro">
        <MContent v-for="(element, index) in contentSchema.outro" :key="index" :config="element.config" />
      </section>
    </template>
  </div>
</template>

<script lang="ts" setup>
import { computed, onBeforeMount } from 'vue'
import { storeToRefs } from 'pinia'
import DefaultVariant from '@/variants/DefaultVariant.vue'
import MiniVariant from '@/variants/mini-variant/MiniVariant.vue'
import { useMessageListeners } from './composables/message-listeners'
import { useCalculatorInitialization } from '@/composables/calculator-initialization'
import { useFormStore } from '@/stores/formStore'
import MContent from '@/components/molecules/M-Content.vue'

const applicationVariants = {
  default: DefaultVariant,
  mini: MiniVariant
}

const { isInitialized, selectedVariant, initializeCalculator } = useCalculatorInitialization(applicationVariants)
const { applicationSchema } = storeToRefs(useFormStore())
const contentSchema = computed(() => applicationSchema.value?.content_schema)

onBeforeMount(initializeCalculator)

useMessageListeners()
</script>
